import accounts from './accounts';
import businesses from './businesses';
import employees from './employees';
import headTransactions from './headTransactions';
import transfers from './transfers';
import individuals from './individuals';
import paymentDetails from './paymentDetails';
import welcome from './welcome';
import solutions from './solutions';
import auditLog from './auditLog';
import pricings from './pricings';
import partners from './partners';
import pnlAccount from './pnlAccount';
import deals from './deals';
import bankAccount from './bankAccount';
import currencies from './currencies';
import beneficiaries from './beneficiaries';
import dealBeneficiaries from './dealBeneficiaries';
import actionReports from './actionReports';
import apiIdentities from './apiIdentities';
import events from './events';
import batches from './batches';
import feedback from './feedback';
import localization from './localization';
import paymentServices from './paymentServices';
import roles from './roles';
import profileTags from './profileTags';
import configuratiosPricing from './configurations/pricing';
import settings from './configurations/settings';
import externalProfileLinks from './externalProfileLinks';
import menu from './menu';
import liquidityBuckets from './liquidityBuckets';
import ledgers from './ledgers';
import applicationRules from './applicationRules';
import scripts from './scripts';
import legalConsents from './legalConsents';
import approvals from './approvals';
import endUsersActivity from './endUsersActivity';
import reports from './reports';

export default {
  agents: {
    name: 'Agent |||| Agents',
  },
  endUsersActivity,
  welcome,
  solutions,
  businesses,
  employees,
  auditLog,
  pricings,
  partners,
  'configurations/settings': settings,
  'configurations/pricing': configuratiosPricing,
  headTransactions,
  transfers,
  individuals,
  accounts,
  kycLevels: {
    name: 'KYC level |||| KYC levels',
    fields: {
      name: 'Name',
      priority: 'Priority',
    },
    reference: {
      create: 'Create KYC level',
      edit: 'Edit level',
      show: 'Go to level',
    },
  },
  locations: {
    name: 'Location |||| Locations',
    reference: {
      create: 'Create location',
      show: 'Go to location',
    },
  },
  paymentDetails,
  terminals: {
    name: 'Terminal |||| Terminals',
    reference: {
      create: 'Create terminal',
      show: 'Go to terminal',
    },
  },
  team: {
    name: 'Dashboard identity |||| Dashboard identities',
    subtitle: 'Manage dashboard identities and their access grants',
    tabs: {
      actionLog: 'Action log',
      sessionHistory: 'Session history',
    },
    fields: {
      username: 'Login',
      name: 'Full name',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phoneNumber: 'Phone number',
      roleId: 'Role',
      lastLogin: 'Last login',
      status: 'Status',
      enabled: 'Enabled',
      // Show
      personalData: 'Personal data',
      profile: 'Profile',
      actionLog: 'Action log',
      sessionHistory: 'Session history',
      // Edit
      editTeamMember: 'Edit identity',
      // Create
      addTeamMember: 'Add identity',
      // Delete
      deleteTeamMemberWarning:
        'By pressing "Confirm" the identity will be completely deleted from the system. The user will not be able to log in to the system and perform any actions. Please confirm.',
      // Audit log
      action: 'Action',
      ipAddress: 'IP address',
      timestamp: 'Timestamp',
      twoFactorAuthWarning:
        'Two-factor authentication would be enabled for this identity when and only when phone number is provided.',
      resetPassword: 'Reset password',
      resetPasswordWarning:
        'By clicking the Confirm button below, the system will send the user an email with a link to set the new password. Please confirm.',
      force2FA: 'Force 2FA on the next login',
      reset2FA: 'Disable 2FA',
      enableIdentity: 'Enable',
      disableIdentity: 'Disable',
      '2FA': '2FA',
      emailVerified: 'Email verified',
      requiredActions: 'Required actions',
    },
  },
  'tenant/accounts': {
    name: "Tenant's Accounts",
    subtitle: "Tenant's Accounts monitoring and configuration",
    ...pnlAccount,
  },
  'bank/accounts': {
    // name: 'Bank accounts',
    subtitle:
      'Liquidity Buckets are used to track synthetic balances, such as "Own Operating Funds", "Customer Deposits (Liabilities)", "Settlement Obligations", etc.',
    ...bankAccount,
  },
  fxrates: {
    name: 'Currency Conversion',
    subtitle: 'Last update',
    tagsHelperText: "To add tag input it's name and press Enter",
    BEST_RATES_OF: 'Best rates of',
    TWO_STEP_CROSSRATE: 'Two-step cross rate',
    ...currencies,
  },
  beneficiaries,
  dealBeneficiaries,
  deals,
  actionReports,
  apiIdentities,
  feedback,
  events,
  batches,
  paymentServices,
  localization,
  externalProfileLinks,
  roles,
  profileTags,
  menu,
  'menu/mappings': {
    name: 'Mappings',
    subtitle: 'Here you can manage the mappings of the dynamic menus',
  },
  liquidityBuckets,
  ledgers,
  'transaction/transfers': {
    name: 'Transfer |||| Transfers',
  },
  applicationRules,
  scripts,
  legalConsents,
  approvals,
  reports,
};
